import {SxProps, Theme} from '@mui/material';
import theme from 'src/theme';
import {addActionButtonSx} from '../actionButton.sx';

export const pageHeaderWrapperSx: SxProps<Theme> = {
    mt: 2.5,
    mb: 2,
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    flexWrap: 'wrap',
    [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        gap: 1.25,
        alignItems: 'stretch',
        // No inset: the heading and its add button share the edge the cards below them stand on.
        // One left edge and one right edge for everything on the page.
        px: 0,
    },
};

export const titleSx: SxProps<Theme> = {
    fontSize: '1.5rem',
    lineHeight: 1.2,
    fontWeight: 600,
    letterSpacing: '-0.015em',
    color: '#007FDC',
    [theme.breakpoints.down('lg')]: {
        fontSize: '1.125rem',
    },
    // On a phone the page's name is a heading, not a banner: the app bar above already carries the
    // blue, and a large blue line under it was the thing that made every screen open with an
    // announcement instead of with its content.
    [theme.breakpoints.down('md')]: {
        fontSize: '17px',
        fontWeight: 600,
        letterSpacing: '-0.01em',
        color: theme.palette.text.primary,
    },
};

export const titleWrapperSx: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    minWidth: 0,
};

export const iconBadgeSx: SxProps<Theme> = {
    width: '40px',
    height: '40px',
    // A badge beside a 17px heading, not beside a 24px one.
    [theme.breakpoints.down('md')]: {
        width: '32px',
        height: '32px',
        borderRadius: '9px',
        '& svg': {
            fontSize: '18px',
        },
    },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '10px',
    background: `linear-gradient(135deg, ${theme.palette.primaryColor[50]} 0%, ${theme.palette.primaryColor[100]} 100%)`,
    color: theme.palette.primary.main,
    flexShrink: 0,
    '& svg': {
        fontSize: '22px',
    },
};

export const actionButtonSx = addActionButtonSx('36px');
